import { isIdleLoadingDesired } from "./idle-loading-desired";

if (isIdleLoadingDesired()) {
  import("./idle-image-loading-init");
}
